import { render, staticRenderFns } from "./PreCode.vue?vue&type=template&id=00d5ba0b&scoped=true&"
import script from "./PreCode.vue?vue&type=script&lang=js&"
export * from "./PreCode.vue?vue&type=script&lang=js&"
import style0 from "./PreCode.vue?vue&type=style&index=0&id=00d5ba0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d5ba0b",
  null
  
)

export default component.exports